import React from 'react'
import Helmet from 'react-helmet'
import removeMd from 'remove-markdown'

const Meta = ({
  title,
  type = 'website',
  url,
  description,
  absoluteImageUrl,
  twitterSiteAccount,
  twitterCreatorAccount
}) => {
  return (
    <Helmet>
      {description && (
        <meta name='description' content={removeMd(description)} />
      )}
      {title && <meta property='og:title' content={title} />}
      {type && <meta property='og:type' content={type} />}
      {url && <meta property='og:url' content={url} />}
      {description && (
        <meta property='og:description' content={removeMd(description)} />
      )}
      {absoluteImageUrl && (
        <meta property='og:image' content={absoluteImageUrl} />
      )}
      <meta name='twitter:card' content='summary_large_image' />
      {twitterSiteAccount && (
        <meta name='twitter:site' content={twitterSiteAccount} />
      )}
      {twitterCreatorAccount && (
        <meta name='twitter:creator' content={twitterCreatorAccount} />
      )}
    </Helmet>
  )
}

export default Meta



// WEBPACK FOOTER //
// ./src/components/Meta.js